export default __webpack_public_path__ + "static/media/teaching_icon.17f70568.webp";